export const CSV_REPORTS_TAGS = {
  TEAM_USERS_CSV: "TeamUsersCsv",
  ORG_PRE_SALES_CSV: "OrgPreSalesCsv",
  EARNINGS_ANALYTICS_CSV: "EarningsAnalyticsCSV",
  TEAM_INTELLIGENCE_CSV: "TeamIntelligenceCsv",
} as const;
